var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ro-type-tag",style:({
        color: _vm.meta.color,
        backgroundColor: _vm.meta.bg,
        borderColor: _vm.meta.color ? `${_vm.meta.color}33` : 'transparent',
    }),attrs:{"title":_vm.meta.approvalHint}},[_c('i',{class:_vm.meta.icon}),_c('span',[_vm._v(_vm._s(_vm.meta.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }